import React, { forwardRef, useImperativeHandle, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { UPDATE_USER_BY_ADMIN } from "redux/features/superAdminSlice/manageUsersSlice/manageUsersGql";
import { hostProfileResolver } from "validators/UserValidation";
import { TextInput } from "shared/Components/textInput";
import { TextArea } from "shared/Components/textarea";
import { globalVariables } from "helper/globalVariables";

export const HostProfile = forwardRef((props, ref) => {
  const { userProfileData, onProfileSuccess, onProfileError, setLoaderState } =
    props || {};
  const [updatedData, setUpdatedData] = useState({});
  const { id } = useParams();

  useImperativeHandle(ref, () => ({
    saveChanges() {
      onCheckValidation();
    },
  }));

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: hostProfileResolver,
    defaultValues: {
      firstName: userProfileData?.name.split(" ")[0],
      lastName: userProfileData?.name.split(" ")[1],
      email: userProfileData?.email,
      location_address: userProfileData?.location_address,
      phoneNumber: userProfileData?.phone_number,
      website: userProfileData?.website,
    },
  });

  const [updateProfile] = useMutation(UPDATE_USER_BY_ADMIN, {
    variables: {
      authId: id,
      data: updatedData,
    },
  });

  const onHandleSubmit = async (credentials) => {
    console.log("credentials", credentials);

    try {
      setLoaderState(true);
      const { data } = await updateProfile({
        variables: {
          authId: id,
          data: {
            first_name: credentials.firstName,
            last_name: credentials.lastName,
            phone_number: credentials.phoneNumber,
            website: credentials.website,
            location_address: credentials.location_address,
          },
        },
      });

      console.log(data.updateUserByAdmin.message); // Handle the response as needed
      onProfileSuccess();
    } catch (error) {
      console.error("Error updating user:", error);
      onProfileError();
    } finally {
      setLoaderState(false);
    }
  };

  const onCheckValidation = () => {
    handleSubmit(onHandleSubmit)();
  };

  return (
    <>
      <div className="mt-6" />
      <form
        className="flex justify-center lg:justify-start pb-[24px]"
        onSubmit={handleSubmit(onHandleSubmit)}
        ref={ref}
      >
        <div className="max-[400px]:w-[90%]">
          <div className="w-full flex justify-center align-center">
            <span className="text-2xl md:text-3xl font-semibold text-gray-900 text-center mb-6">
              {globalVariables.userDetails}
            </span>
          </div>
          <TextInput
            register={register}
            name="firstName"
            placeholder={globalVariables.firstName}
            errorMsg={errors.firstName?.message}
            label={globalVariables.firstName}
          />
          <div className="mt-5" />
          <TextInput
            register={register}
            name="lastName"
            placeholder={globalVariables.lastName}
            errorMsg={errors.lastName?.message}
            label={globalVariables.lastName}
          />
          <div className="mt-5" />
          <TextArea
            register={register}
            name="location_address"
            placeholder={globalVariables.address}
            errorMsg={errors.address?.message}
            label={globalVariables.address}
          />
          <div className="mt-5" />
          <TextInput
            register={register}
            name="email"
            placeholder={globalVariables.emailId}
            errorMsg={errors.email?.message}
            label={globalVariables.emailId}
            disabled
            textTransform="normal-case"
          />
          <div className="mt-5" />
          <TextInput
            register={register}
            name="phoneNumber"
            placeholder={globalVariables.enterPhoneNumber}
            errorMsg={errors.phoneNumber?.message}
            label={globalVariables.phoneNumber}
          />
          <div className="mt-5" />
          <TextInput
            register={register}
            name="website"
            placeholder={globalVariables.website}
            errorMsg={errors.website?.message}
            label={globalVariables.website}
            textTransform="normal-case"
          />
        </div>
      </form>
    </>
  );
});
